<div class="layui-collapse" lay-accordion="">
  <div class="layui-colla-item">
    <h2 class="layui-colla-title">如何申请成为咨询师？</h2>
    <div class="layui-colla-content layui-show">
      <p>咨询师申请入口：“个人中心”-“设置”-“申请入驻”-“咨询师”，申请咨询师需要满足以下要求： <br>
      1.个人资料完善度大于等于100%。 <br>
      2.接听时长大于等于2小时。 <br>
      3.接听人数大于等于10人。
      </p>
    </div>
  </div>
  <div class="layui-colla-item">
    <h2 class="layui-colla-title">如何申请成为专家？</h2>
    <div class="layui-colla-content">
      <p>平台专家实行邀请制，如您想入驻本平台，请联系客服QQ2893077285。</p>
    </div>
  </div>
  <div class="layui-colla-item">
    <h2 class="layui-colla-title">申请咨询师后什么时候通过？</h2>
    <div class="layui-colla-content">
      <p>提交申请咨询师后，需1~2个工作日完成审核，审核成功后将通过站内信的方式通知您。</p>
    </div>
  </div>
  <div class="layui-colla-item">
    <h2 class="layui-colla-title">如何提现？提现什么时候到账？</h2>
    <div class="layui-colla-content">
      <p>
      1.提现入口：“个人中心”-“我的账户”-“提现”-“绑定本人银行卡”。<br>
      2.周一提现，本周五到账、周二至周日提现，则第二周的周五到账。 <br>
      3.第一次提现，满100元即可提现；之后提现需满300元方可提现，且提现金额须为100的整数倍。
      </p>
    </div>
  </div>
</div>